import { track } from '@vercel/analytics';
import { z } from 'zod';

const eventSchema = z.object({
  name: z.enum([
    'copy_npm_command',
    'copy_code_block',
    'play_name_pronunciation',
    'open_command_menu',
    'command_menu_search',
    'command_menu_action',
    'blog_search',
    'case_study_race_play',
    'case_study_race_scrub',
    'case_study_race_speed',
    'case_study_leak_open',
    'case_study_mechanism_open',
    'case_study_rollout_stage',
    'case_study_filter_change',
    'case_study_filters_reset',
  ]),
  properties: z
    .record(z.union([z.string(), z.number(), z.boolean(), z.null()]))
    .optional(),
});

export type Event = z.infer<typeof eventSchema>;

/**
 * Sends a custom event to Vercel Web Analytics.
 *
 * `track` is a no-op until the <Analytics /> script has mounted, which only
 * happens after the visitor grants measurement consent (see
 * consent-manager-scripts.tsx), and in development it only logs.
 *
 * Note: custom events are a Pro-plan feature. On Hobby these calls are
 * harmless but the events are not retained or queryable.
 */
export function trackEvent(input: Event) {
  const event = eventSchema.parse(input);

  if (typeof window === 'undefined') return;

  track(event.name, event.properties);
}
